import { siloUtil } from './siloUtil';

const Silo = {
   siloUtil
};

export { Silo };


// WEBPACK FOOTER //
// ./src/AAF/Silo/main.js